const categoryBanners = [
  {
    slug: 'wine',
    imageUrl:
      'https://cdn.winelivery.com/public/app/banners/invia_sorpresa.png',
    href: '/fai-un-regalo',
  },
  {
    slug: 'beer',
    imageUrl: 'https://cdn.winelivery.com/public/app/banners/birre_00.png',
    href: '/shop?category=beer&subcategory=alcohol-free',
  },
  {
    slug: 'cocktails',
    imageUrl:
      'https://cdn.winelivery.com/public/app/banners/crea_il_cocktail.png',
    href: '/create-your-cocktail',
  },
  {
    slug: 'drink',
    imageUrl: 'https://cdn.winelivery.com/public/app/banners/gin_discovery.png',
    href: 'https://cdn.winelivery.com/public/gin-discovery/index.html',
    target: '_blank',
  },
  {
    slug: 'snack-and-appetizers',
    imageUrl:
      'https://cdn.winelivery.com/public/app/banners/aperitivo_chic.png',
    href: '/shop?occasion=glamour-aperitif',
  },
  {
    slug: 'ice-and-water',
    imageUrl: 'https://cdn.winelivery.com/public/app/banners/water_codex.png',
    href: 'https://cdn.winelivery.com/public/water-codex/index.html',
    target: '_blank',
  },
  {
    slug: 'soft-drinks',
    imageUrl: 'https://cdn.winelivery.com/public/app/banners/alcool_free.png',
    href: '/shop?tag=zeroalcol',
  },
  {
    slug: 'accessories',
    imageUrl: 'https://cdn.winelivery.com/public/app/banners/tappo_shop.png',
    href: '/wallet',
  },
];

export function getBanner(slug: string) {
  return categoryBanners.find((banner) => banner.slug === slug);
}
